import { useState, useEffect, useRef, ReactNode } from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.css";

export function useModal(defaultVisible = false) {
  const [visible, setVisible] = useState(defaultVisible);
  const [value, setValue] = useState(null);

  function show(value = null) {
    document.body.style.overflow = "hidden";
    document.getElementById("root").style.filter = "blur(6px)";
    setVisible(true);
    setValue(value);
  }

  function close() {
    document.body.style.overflow = "";
    document.getElementById("root").style.filter = "";
    setVisible(false);
    setValue(null);
  }

  return { visible, value, show, close };
}

const createRoot = () => {
  const root = document.createElement("div");
  root.classList.add("modal-root");
  return root;
};

const Modal = ({ children, header, closeModal, visible }: ModalType) => {
  const container = useRef(createRoot());

  useEffect(() => {
    if (visible) {
      document.body.appendChild(container.current);
      document.onkeydown = (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          closeModal && closeModal(e);
        }
      };
    } else {
      container.current.remove();
    }
  }, [visible]);

  return !visible
    ? null
    : ReactDOM.createPortal(
        <custom-modal
          onCancel={(e) => {
            e.preventDefault();
            closeModal && closeModal(e);
          }}
        >
          <div className={styles.modalHeader}>
            {header}
            {closeModal && (
              <span className={styles.modalClose} onClick={closeModal}>
                ✕
              </span>
            )}
          </div>
          {children}
        </custom-modal>,
        container.current,
      );
};
type ModalType = {
  visible: boolean;
  children: ReactNode;
  header?: ReactNode;
  closeModal: () => void;
};

export const ActionBar = (props) => (
  <div className={styles.actionBar} {...props} />
);

export const Content = (props: any) => (
  <div className={styles.modalContent} {...props} />
);

export default Modal;

class ModalElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._render();
  }

  _render() {
    const container = document.createElement("div");
    container.innerHTML = `
      <style>
        .wrapper {
          justify-content: center;
          display: flex;
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(30, 61, 58, 0.5);
          z-index: 10000;
          overflow-y: scroll;
        }
        .modal-box {
          display: block;
          min-width: 700px;
          max-width: 100%;
          max-height: 100%;
          margin: auto;
        }
        .modal-inner {
          display: block;
          background-color: #fff;
          border-radius: 32px;
          padding: 32px;
          margin: 15px;
          box-shadow: 0px 3px 5px #00000029;
        }
      </style>
      <div class="wrapper">
        <div class="modal-box">
          <div class="modal-inner">
            <slot></slot>
          </div>
        </div>
      </div>`;

    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.appendChild(container);
  }
}
window.customElements.define("custom-modal", ModalElement);
